import React, { useState } from 'react';

const JobListGlobalFilter = () => {
    const [selectDate, setSelectDate] = useState();
    const dateChange = (date) => {
        setSelectDate(date)
    };
    return (
        <React.Fragment>
            <div className='col-xxl-2'>
                <select className="form-control select2 mb-3 mb-xxl-0">
                    <option>Status</option>
                    <option value="Active">Active</option>
                    <option value="New">New</option>
                    <option value="Close">Close</option>
                </select>
            </div>
            <div className='col-xxl-2'>
                <select className="form-control select2 mb-3 mb-xxl-0">
                    <option>Select Type</option>
                    <option value="1">Full Time</option>
                    <option value="2">Part Time</option>
                </select>
            </div>
            <div className='col-xxl-2'>
                <div id="datepicker1">
                    {/* <DatePicker
                        className="form-control mb-3 mb-xxl-0"
                        selected={selectDate}
                        onChange={dateChange}
                    /> */}
                </div>
            </div>
            <div className='col-xxl-2'>
                <div className='mb-3 mb-xxl-0'>
                    <button type="button" className="btn btn-soft-secondary w-100">
                        <i className="mdi mdi-filter-outline align-middle"></i> Filter</button>
                </div>
            </div>
        </React.Fragment>
    )
};

export default JobListGlobalFilter;

